module.exports = __webpack_public_path__ + "img/img_cat.faa3e0fe.png";